import { Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { ICustomer, ICustomerReq, ICustomerRes } from '@/interfaces/customer';
import { AxiosResponse } from 'axios';
import { searchCustomer } from '@/adapters/customer';
import { useCallback, useState } from 'react';
import { debounce } from 'lodash';
// import { twMerge } from 'tailwind-merge';

interface IProps {
  disabled?: boolean;
  value?: string;
  customer?: ICustomer;
  size?: SizeType;
  isAll?: boolean;
  handleSelectData: (customer: ICustomer) => void;
  readonly?: boolean;
  customClass?: string;
  allowClear?: boolean;
}

const _criteria: ICustomerReq = {
  search: '',
};

const CustomerSelector = ({
  disabled = false,
  value,
  size = 'large',
  handleSelectData,
  isAll = false,
  readonly = false,
  customer,
  customClass,
  allowClear = true,
}: IProps) => {
  const [criteria, setCriteria] = useState<ICustomerReq>({ ..._criteria });

  const { data: customers, isLoading } = useQuery<
    AxiosResponse<ICustomerRes>,
    Error
  >({
    queryKey: ['search-customer', criteria],
    queryFn: async () => await searchCustomer(criteria),
  });

  let groupOptions =
    customers?.data?.data?.map((g) => {
      return {
        value: `${g.CMAD_ID}`,
        label: `${g.CMAD_NAME} (${g.CMAD_ID})`,
      };
    }) || [];

  const allOptions = [{ value: '', label: 'ทั้งหมด' }, ...groupOptions];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    debounce((value) => {
      setCriteria({
        ...criteria,
        search: value,
      });
    }, 300),
    []
  );

  const onChange = (value: string) => {
    const customerInfo = customers?.data?.data?.find(
      (d) => d.CMAD_ID === value
    );
    handleSelectData(customerInfo as ICustomer);
  };

  if (customer) groupOptions = [...groupOptions];
  return (
    <Select
      allowClear={allowClear}
      showSearch
      loading={isLoading}
      value={value}
      className={customClass}
      size={size}
      placeholder="เลือกลูกค้า"
      onChange={(value) => onChange(value)}
      onSearch={debouncedSearch}
      onClear={() => onChange('')}
      options={isAll ? allOptions : [...groupOptions]}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      disabled={readonly || isLoading || disabled}
    />
  );
};

export default CustomerSelector;
